import React from "react";
import PropTypes from "prop-types";

export default class Thumbnail extends React.Component {
  render() {
    return (
      <li className="photo__item">
        <a
          className="photo__item-link"
          href="#"
          onClick={this._handleClick.bind(this)}
        >
          <figure className="photo__item-img">
            <img
              src={this.props.photo.url.thumbnail}
              alt={`${this.props.photo.hall_name} ${this.props.photo.caption}`}
              width="157"
              height="157"
              loading="lazy"
            />
          </figure>
        </a>
      </li>
    );
  }

  _handleClick(e) {
    e.preventDefault();
    this.props.clickPhoto(this.props.index);
  }
}

Thumbnail.propTypes = {
  photo: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  clickPhoto: PropTypes.func.isRequired,
};
